import Translate from './Translate';
import translateFromStore from './translateFromStore';

export const translate = translateFromStore;
export default Translate;
